import NotFound from '../components/NotFound';

export default function NotFoundPage() {
	return (
		<div style={{minHeight:'100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
			<NotFound/>
		</div>
	)
}